import PaginationModel from "@/models/paginationModel";
import SetorModel from "@/models/setorModel";
import nfetch from "@/utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class SetorService extends iServiceCached<SetorModel> {
    constructor() {
        super("Setor");
    }

    public getAll(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetAll`, {
            credentials: "same-origin",
        });
    }

    public async comboCached(franquiaId: number) {
        if (!this.cached[franquiaId]) {
            const franquiaParam = franquiaId ? `franquiaId=${franquiaId}` : "";
            const response = await nfetch(`/${this.controllerName}/List?${franquiaParam}`, {
                credentials: "same-origin",
            })
                .withLoading()
                .resolveWithJSON<PaginationModel<SetorModel>>(false);

            this.cached[franquiaId] = response?.list ?? [];
        }

        return this.cached[franquiaId].map(p => ({ value: p.id, text: p.descricao }));
    }
}

export default new SetorService();
